import { Box, Tooltip } from "@chakra-ui/react";
import { FaFilter } from "react-icons/fa";
import * as React from "react";
import { useTranslation } from "react-i18next";

function AppliedFilterIcon({ filterCategory, categories }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "supplierAdminDashboard"
  });

  return (
    <Box marginLeft={1}>
      <Tooltip
        label={t("categoryFilterApplied", {
          category: categories?.find(cat => cat.id === filterCategory)?.name ?? ""
        })}
        whiteSpace={"pre-line"}
        hasArrow
        fontSize={"md"}
        height={"unset"}
      >
        <span>
          <FaFilter color={"green"} opacity="0.7" />
        </span>
      </Tooltip>
    </Box>
  );
}

export default AppliedFilterIcon;